import { render } from "./ClientTable.vue?vue&type=template&id=96872e96&scoped=true"
import script from "./ClientTable.vue?vue&type=script&lang=js"
export * from "./ClientTable.vue?vue&type=script&lang=js"

import "./ClientTable.vue?vue&type=style&index=0&id=96872e96&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96872e96"]])

export default __exports__